import React from "react";
// import commonBanner
import CommonBanner from "../component/Common/CommonBanner";
// import ContactArea
import ContactArea from "../component/Contact";
import { Helmet } from "react-helmet-async";
import { ImageConstants } from "../assets/img/ImageConstants";
import DynamicSEOTags from "../component/DynamicSEO/DynamicSEOTags";
const Contact = () => {
  return (
    <>
      <DynamicSEOTags
        fallbackTitle="Your Page Title"
        fallbackDescription="Your page description"
        fallbackKeywords="your, keywords, here"
        fallbackOgTitle="Your OG Title"
        fallbackOgDescription="Your OG Description"
        fallbackCanonicalUrl="https://yoursite.com/your-page"
      />

      {/* <CommonBanner heading="Contact" pagination="Contact" />
       */}
      <CommonBanner
        heading="Contact"
        img={ImageConstants.contact}
        pagination="Contact"
      />
      <ContactArea />
    </>
  );
};

export default Contact;
